<section class="branch-assignment-override mb-4">
  <h5 class="fw-semibold text-primary mb-4">Branch Assignment Override</h5>

  <ng-template
    #travelDateField
    let-lineKey="lineKey"
    let-lineId="lineId"
    let-field="field"
    let-value="value"
    let-label="label"
    let-ariaLabel="ariaLabel"
    let-minDate="minDate"
    let-initialDate="initialDate"
  >
    <span class="form-label mb-0">{{ label }}</span>
    <div class="position-relative">
      <input
        #dateAnchor
        type="text"
        readonly
        class="form-control form-control-sm pe-4"
        [value]="formatDateForDisplay(value)"
        placeholder="Select date"
        [disabled]="!!lineId"
        (click)="!lineId && travelStore.toggleDatePicker(lineKey + '-' + field, dateAnchor)"
        [style.cursor]="lineId ? 'not-allowed' : 'pointer'"
        style="width: 150px"
        [attr.data-testid]="field === 'startDate' ? 'travel-start-date-input' : 'travel-end-date-input'"
      />
      <button
        type="button"
        class="btn btn-sm p-0 border-0 position-absolute top-50 end-0 translate-middle-y me-2"
        [disabled]="!!lineId"
        (click)="travelStore.toggleDatePicker(lineKey + '-' + field, dateAnchor)"
        [attr.aria-label]="ariaLabel"
      >
        <i class="bi bi-calendar-check"></i>
      </button>
      @if (!lineId && travelStore.isPickerOpen(lineKey + '-' + field)) {
        <div
          class="position-absolute start-0 bg-white border rounded shadow-lg z-1000"
          [class.top-100]="travelStore.pickerPlacement(lineKey + '-' + field) === 'below'"
          [class.mt-1]="travelStore.pickerPlacement(lineKey + '-' + field) === 'below'"
          [class.bottom-100]="travelStore.pickerPlacement(lineKey + '-' + field) === 'above'"
          [class.mb-1]="travelStore.pickerPlacement(lineKey + '-' + field) === 'above'"
        >
          <groundworks-date-picker
            data-testid="travel-date-picker"
            [isRangeSelection]="false"
            [displayMonths]="1"
            [selectedDate]="initialDate"
            [minDate]="minDate"
            (fromDateEvent)="handleDate(lineKey, field, $event)"
          />
        </div>
      }
    </div>
  </ng-template>

  @for (line of visibleLines(); track line.lineKey) {
      <div class="travel-line mb-3" data-testid="travel-line">
          <div class="d-flex align-items-center gap-2 mb-2">
            <ng-container
              [ngTemplateOutlet]="travelDateField"
              [ngTemplateOutletContext]="{
                lineKey: line.lineKey,
                lineId: line.id,
                field: 'startDate',
                value: line.startDate,
                label: 'From:',
                ariaLabel: 'Toggle start date picker',
                minDate: undefined,
                initialDate: parseIsoDate(line.startDate)
              }"
            />
            <ng-container
              [ngTemplateOutlet]="travelDateField"
              [ngTemplateOutletContext]="{
                lineKey: line.lineKey,
                lineId: line.id,
                field: 'endDate',
                value: line.endDate,
                label: 'to:',
                ariaLabel: 'Toggle end date picker',
                minDate: parseIsoDate(line.startDate),
                initialDate: parseIsoDate(line.endDate) ?? parseIsoDate(line.startDate)
              }"
            />

            <ng-select
              class="branch-select"
              data-testid="travel-branch-select"
              [items]="availableBranches()"
              bindLabel="name"
              bindValue="id"
              placeholder="Select branch"
              [ngModel]="line.destinationBranchId"
              (ngModelChange)="travelStore.updateField(line.lineKey, 'destinationBranchId', $event)"
              [clearable]="false"
              [readonly]="!!line.id"
              style="min-width: 180px"
            />

            <button
              type="button"
              class="btn btn-sm p-0 border-0 ms-auto"
              data-testid="travel-remove-line"
              (click)="travelStore.removeLine(line.lineKey)"
              aria-label="Remove travel line"
            >
              <i class="bi bi-trash text-danger"></i>
            </button>
            @if (travelStore.isLastVisibleLine(line.lineKey)) {
              <button
                type="button"
                class="btn btn-sm p-0 border-0"
                data-testid="travel-add-line"
                (click)="travelStore.addLine()"
                aria-label="Add travel line"
              >
                <i class="bi bi-plus-circle-fill text-secondary"></i>
              </button>
            }
          </div>

          @if (configService.enableCrew) {
            <div class="mt-2">
              <ng-select
                data-testid="travel-crew-select"
                [items]="travelStore.getEligibleCrewForLine(line.lineKey)"
                [multiple]="true"
                bindLabel="name"
                bindValue="userId"
                placeholder="Select crew members"
                [ngModel]="line.crewMemberIds"
                (ngModelChange)="travelStore.updateCrew(line.lineKey, $event)"
                (open)="onCrewDropdownOpen(line.lineKey)"
                [loading]="travelStore.isCrewLoadingFor(line.lineKey)"
                [closeOnSelect]="false"
                [clearSearchOnAdd]="true"
              >
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  @for (item of items; track item) {
                    <div class="ng-value bg-body-secondary">
                      <span class="ng-value-label text-primary">{{ item.name }}</span>
                      <button
                        type="button"
                        class="ng-value-icon right border-0 bg-transparent p-0 ms-1 me-1 text-primary"
                        (click)="clear(item)"
                        aria-label="Remove"
                      >
                        ×
                      </button>
                    </div>
                  }
                </ng-template>
              </ng-select>
            </div>
          }
      </div>
  }

  @if (hasNoVisibleLines()) {
    <button
      type="button"
      class="btn btn-sm p-0 border-0"
      data-testid="travel-add-line"
      (click)="travelStore.addLine()"
      aria-label="Add travel line"
    >
      <i class="bi bi-plus-circle-fill text-secondary"></i>
    </button>
  }
</section>
